var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedMessageStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message Status"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.90759 3.1875V5.375M4.91177 6.6875H4.90759M1.87631 8H7.93848C8.61206 8 9.03304 7.27083 8.69626 6.6875L5.66517 1.4375C5.32838 0.854167 4.48641 0.854167 4.14962 1.4375L1.11853 6.6875C0.781746 7.27083 1.20273 8 1.87631 8Z",
    stroke: "#F31260",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedMessageStatus);
export default __webpack_public_path__ + "static/media/failed-message-status.16a1d1c4d015e99bac4c03bf57418248.svg";
export { ForwardRef as ReactComponent };